"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_SHAPES = void 0;
var BUTTON_SHAPES = Object.freeze({
  circle: 'circle',
  square: 'square'
});
exports.BUTTON_SHAPES = BUTTON_SHAPES;